import store from '../../../store';
import axios from 'axios';

class OrderPageService {
  async handle() {
    const order = store.getters['shopify/order/get'];

    if (!order) {
      // TODO: log that order page has no order on it ..
      return;
    }

    // if local storage has items
    if (!store.getters['local/recommendations/get']) {
      // Customer did not request any recommendations
      return;
    }

    // update recommendations with line_item_id
    await this.updateRecommendationsWithLineItems(order.line_items);

    // collect recommendations related to current order
    const recommendations = await this.getRecommendationsByLineItems(order.line_items);

    if (!recommendations.length) {
      // we have some recommendations, but they aren't for ordered products
      return;
    }

    // collect post data
    const data = {
      shop: store.getters['shopify/shop/get'],
      customer: store.getters['shopify/customer/get'],
      order: order,
      recommendations: recommendations,
      line_item_recommendations_key: recommendations[0].line_item_recommendations_key,
    };

    axios.post('/api/shopify/recommendation/order', data)
      .then(async(response) => {
        await this.clearRecommendations(recommendations);
      })
      .catch((e) => {
        // TODO: log error
        throw e;
      });
  }

  async updateRecommendationsWithLineItems(lineItems) {
    const recommendations = store.getters['local/recommendations/get'];
    // map recommendations to order line items
    Object.entries(recommendations).forEach(async([index, recommendation]) => {
      if (recommendation.id != null) return; // skip if recommendation was already processed
      if (recommendation.line_item_id != null) return; // seems like recommendation was processed but not saved

      const productId = recommendation.line_item.product.external_id;

      // search productId in line items (backend stores remote id's as strings)
      const lineItem = lineItems.find(item => {
        return item.product_id.toString() === productId.toString();
      });
      if (!lineItem) return;

      // update with line_item_id
      await store.dispatch('local/recommendations/put', {
        line_item: {
          external_id: lineItem.id,
          product: {
            external_id: productId,
          },
          variant: {
            external_id: lineItem.variant_id,
          },
        },
      });
    });
  }

  async getRecommendationsByLineItems(lineItems) {
    const recommendations = store.getters['local/recommendations/get'];

    // search for recommendations that have specified line items
    return Object.values(recommendations).filter(recommendation => {
      if (recommendation.id != null) return false; // skip if recommendation was already processed

      // search for line item related to recommendation
      const lineItem = lineItems.find((lineItem) => {
        return lineItem.id === recommendation.line_item.external_id;
      });

      return (lineItem != null);
    });
  }

  async clearRecommendations(recommendations) {
    Object.entries(recommendations).forEach(async([index, recommendation]) => {
      const productId = recommendation.line_item.product.external_id;
      await store.dispatch('local/recommendations/delete', {
        line_item: {
          product: {
            external_id: productId,
          },
        },
      });
    });
  }
}

export default new OrderPageService();
